export type Task = () => Promise<void>;

export class TaskQueue {
    private queue: Task[] = [];
    private processing: boolean = false;

    add(task: Task) {
        this.queue.push(task);

        void this.process();
    }

    clear() {
        this.queue = [];
    }

    private async process() {
        if (this.processing) {
            return;
        }

        this.processing = true;

        while (true) {
            const task = this.queue.shift();

            if (!task) {
                break;
            }

            try {
                await task();
            } catch (error) {
                console.error('Task failed:', error);
            }
        }

        this.processing = false;
    }
}

export const taskQueue = new TaskQueue();
